import styled from 'styled-components/macro';
import StyledFlexContainer from './StyledFlexContainer';
const WorkFilter = styled(StyledFlexContainer)`
	flex-direction: row;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	margin: 4rem 0 2rem;
	gap: 1rem;
`;

export default WorkFilter;
